import getImageSrc from "../utils/getImgSrc";

const setAllImgSrcs = () => {
    document.querySelectorAll('[data-img-src-key]').forEach((img) => {
        img.src = getImageSrc(img.dataset.imgSrcKey);
    })
};

document.addEventListener('DOMContentLoaded', setAllImgSrcs);
let resize;
window.addEventListener('resize', () => {
  clearTimeout(resize);
  resize = setTimeout(setAllImgSrcs, 100); 
});
